import { motion } from "framer-motion";

export default function Loader() {
  return (
    <motion.div
      className="loader"
      data-testid="loader"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="text-center">
        <div className="text-6xl md:text-7xl mb-3">☺</div>
        <div className="font-display text-3xl md:text-4xl">um segundo</div>
      </div>
    </motion.div>
  );
}
